export default {"src":"/_next/static/media/home-mask-hand.e177a5c2.svg","height":86,"width":137,"blurWidth":0,"blurHeight":0};